export default __webpack_public_path__ + "static/media/FuturaSBOP-Round.f8d43047.woff2";